import { IconFacebook, IconIn, IconInstagram, IconTelegram } from '@shared/assets'
import styles from './SocialBar.module.scss'
import { Link } from 'react-router-dom'
import { useContactsQuery } from '@shared/api/useContactsQuery'

export const SocialBar = () => {
  const { data } = useContactsQuery()
  if (!data || data.length === 0) return null

  const social = [
    { id:1, icon: <IconTelegram/>, url:data[0]?.telegram_link },
    { id:2, icon: <IconInstagram/>, url:data[0]?.instagram_link },
    { id:3, icon: <IconFacebook/>, url:data[0]?.facebook_link },
    { id:4, icon: <IconIn/>, url:data[0]?.linkedin_link },
  ]
  return (
    <div className={styles.social}>
      {social.map((item) =>
        item.url && (
          <Link
            className={styles.link}
            key={item.id}
            to={item.url}
            target='_blank'
            rel='noopener noreferrer'
          >
            {item.icon}
          </Link>
        )
      )}
    </div>
  )
}
